import jQuery from "jquery";
import PaymentSelector from "./payment_selector";
import {
    csrfToken,
    planneParam,
    getMetaContent,
    inIframe,
    getQueryParam,
} from "../helpers";
import { parseDate, monthNames, weekdayNames } from "../../common/calendar";
import { setupFingerprint } from "../../common/fingerprint";

export const setup = () => {
    addJsClassToBody();
    setupDatepickers();
    setupSearchDatepickers();
    setupInputMasks();
    setupOverwritedLinks();
    // setupGoogleMaps();
    setupPaymentSelectors();
    setupTypeSelectors();
    setupButtonValueImporters();
    setupCKEditor();
    setupEditorImageOptions();
    setupRemoteAutocomplete();
    setupVoucherSecretInput();
    setupAutoreloadForm();
    setupCheckboxDisplayControl();
    setupAppSelector();
    setupCookieNotice();
    setupCopyToClipboard();
    prepareFingerprint();
    setupDisplayModalCode();
    setupRevokedVoucherNavigation();
    setupSelect2();
    setupLinksInIframe();
    refundRequestButton();
    setupMessageListener();
    customerDetailsButton();
    sidebarButton();
    showTariffVerifications();
    serviceFeeButton();
    associateServiceFeeButton();
    tariffGroupAttributesButton();
    upsellOfferCreateButton();
    upsellOfferEditButton();
};

const addJsClassToBody = () => $("body").addClass("js");

export const setupDatepickers = () => {
    $(".datepicker").each(function () {
        setupDatepicker(this);
    });

    $.datetimepicker.setLocale("pt-BR");

    $(".datetimepicker").each(function () {
        setupDateTimePicker(this);
    });
};

export const setupDatepicker = (el, onSelection) => {
    const dateFormat = "dd/mm/yy";
    const altFormat = "yy-mm-dd";
    const changeMonth = true;
    const changeYear = true;
    const initAttrName = "datepicker-initialized";

    const $el = $(el);
    if ($el.attr(initAttrName)) return;

    const name = $el.attr("name");
    const enableClear = !!$el.data("enable-clear");
    const id = "id_datepicker_" + name.replace(/[\[\]]/g, "_");
    const value = $el.val();

    const $altField = $("<input>", { id, name, type: "hidden" }).insertBefore(
        $el
    );

    const $clear = $("<a>", {
        href: "javascript:void(0)",
        class: "datepicker-clear",
        text: "Limpar",
    })
        .insertAfter($el)
        .hide();
    const resetAll = () => {
        $el.datepicker("setDate", null);
        $clear.hide();
    };
    $clear.click(resetAll);

    const onSelect = (dateTxt) => {
        if (enableClear) $clear.show();

        if (onSelection) onSelection(dateTxt);
    };

    $el.attr("name", `datepicker_${name}`);
    $el.attr(initAttrName, true);
    $el.datepicker({
        dateFormat,
        altField: `#${id}`,
        altFormat,
        changeMonth,
        changeYear,
        onSelect,
        yearRange: "1920:2300",
    });
    $el.change((ev) => {
        if (ev.target.value === "") resetAll();
    });

    if (value) {
        if (enableClear) $clear.show();

        if (value.match(/\d{4}-\d{2}-\d{2}/)) {
            const d = parseDate(value);
            $el.datepicker("setDate", d);
            $altField.val(value);
        }
    }
};

export const setupDateTimePicker = (el, onSelection) => {
    const $el = $(el);

    const format = "d/m/Y H:i";

    $el.datetimepicker({
        i18n: {
            "pt-BR": {
                months: monthNames,
                dayOfWeek: weekdayNames,
            },
        },
        defaultTime: "23:59",
        step: 1,
        format,
        lang: "pt-BR",
    });
};

export const teardownDatepicker = (el) => {
    const $el = $(el);
    $el.datepicker("destroy");
};

const setupSearchDatepickers = () => {
    const $form = $(".search-date-form");
    $form
        .find(".datepicker")
        .datepicker("option", "onSelect", () => $form.submit());
};

const setupInputMasks = () => {
    $(".cpf-cnpj-mask").mask("00000000000999");
    $(".phone-mask").mask("+00 (00) 90000-0000");
    $(".card-number-mask").mask("999999999999999999999");
    $(".security-code-mask").mask("999999");
    $(".zip-code-mask").mask("00000-000");
};

const setupOverwritedLinks = () => {
    $(".overwrite-method").click(function (ev) {
        ev.preventDefault();

        const submitForm = (anchor, data = {}) => {
            const $form = $("<form>", { action: anchor.href, method: "post" });

            const _token = csrfToken();
            const _method = anchor.dataset.httpMethod;
            data = { ...data, _token, _method };

            for (let name in data) {
                const value = data[name];
                $form.append($("<input>", { type: "hidden", name, value }));
            }

            $form.appendTo(document.body).submit();
        };

        const { httpMethod, prompValue, deleteMessage, needsConfirmMessage } =
            this.dataset;

        switch (true) {
            case !!prompValue:
                const value = prompt("Valor");
                if (!!value) submitForm(this, { [prompValue]: value });

                break;
            case $(this).hasClass("needs-confirm"):
                if ($(this).hasClass("has-refund-request")) {
                    if (
                        !confirm(
                            "Há um estorno em processamento para esta venda. Tem certeza que deseja consumir o voucher? A ação é irreversível."
                        )
                    )
                        return;
                }

                if (
                    confirm(
                        needsConfirmMessage ||
                            "Você tem certeza sobre essa ação?"
                    )
                )
                    submitForm(this);

                break;
            case httpMethod === "delete" && this.text == "archive":
                if (
                    confirm(
                        deleteMessage ??
                            "Tem certeza que deseja arquivar esse item?"
                    )
                )
                    submitForm(this);

                break;
            case httpMethod === "delete":
                const message =
                    deleteMessage ||
                    "Tem certeza que deseja excluir esse item?";
                if (confirm(message)) submitForm(this);

                break;
            default:
                submitForm(this);
        }
    });
};

const setupGoogleMaps = () => {
    var key = planneParam("google_maps_key");
    var callbackFunctionName = "gMapsCallback";
    window[callbackFunctionName] = this.setupGoogleMapsCallback.bind(this);

    var script = document.createElement("script");
    script.defer = true;
    script.async = true;
    script.src =
        "https://maps.googleapis.com/maps/api/js?key=" +
        key +
        "&callback=" +
        callbackFunctionName;

    document.body.appendChild(script);
};

const setupGoogleMapsCallback = () => {
    // this.setupSelectionMap();
};

// setupSelectionMap(){
//
// }

const setupPaymentSelectors = () => {
    $(".payment-selector").each(function () {
        var $el = $(this);
        var selector = new PaymentSelector($el);
    });
};

const setupTypeSelectors = () => {
    $(".type-selector").each(function () {
        const $el = $(this);
        const className = $el.data("type-class");

        const handleChange = () => {
            const value = $el.val();

            $(`.${className}`).hide();
            $(`.${className}.type-${value}`).show();
        };

        handleChange();
        $el.change(handleChange);
    });
};

const setupButtonValueImporters = () => {
    $(".import-value-input").each(function (index) {
        var $el = $(this);
        $el.click(function (ev) {
            var $from = $("#" + $el.data("from"));
            var $to = $("#" + $el.data("to"));

            $to.val($from.val());

            ev.preventDefault();
        });
    });
};

const setupCKEditor = () => {
    CKEDITOR.on("instanceReady", function (evt) {
        evt.editor.dataProcessor.htmlFilter.addRules({
            elements: {
                img: function (el) {
                    el.addClass("responsive-img");
                },
            },
        });
    });

    $(".full-editor").each(function () {
        const $el = $(this);

        const options = {
            extraAllowedContent: "iframe[src,width,height,frameborder,allow]",
            versionCheck: false,
            entities_latin: false,
        };

        if ($el.data("filebrowser-url")) {
            options.filebrowserImageBrowseUrl = $el.data("filebrowser-url");
        }

        if ($el.data("fileupload-url")) {
            options.filebrowserImageUploadUrl = $el.data("fileupload-url");
        }

        CKEDITOR.replace(this, options);
    });
};

const setupEditorImageOptions = () => {
    $(".editor-image-option").each(function () {
        var $el = $(this);

        $el.click(function () {
            var funcNum = $el.data("func-num");
            var fileUrl = $el.data("file-url");
            var fileAlt = $el.data("file-alt");

            window.opener.CKEDITOR.tools.callFunction(
                funcNum,
                fileUrl,
                function () {
                    var dialog = this.getDialog();
                    if (dialog.getName() == "image" && fileAlt) {
                        var element = dialog.getContentElement(
                            "info",
                            "txtAlt"
                        );
                        if (element) element.setValue(fileAlt);
                    }
                }
            );
            window.close();
        });
    });
};

const setupRemoteAutocomplete = () => {
    $(".remote-autocomplete").each(function () {
        const $el = $(this);
        const source = $el.data("search-url");

        $el.autocomplete({ source, minLength: 1 });
    });
};

const setupVoucherSecretInput = () => {
    $(".voucher-secret-input").each(function () {
        var $el = $(this);
        $el.keyup(function () {
            var value = $el.val().toUpperCase();
            var selStart = $el[0].selectionStart;
            var selEnd = $el[0].selectionEnd;

            $el.val(value);
            $el[0].selectionStart = selStart;
            $el[0].selectionEnd = selEnd;
        });
    });
};

const setupAutoreloadForm = () => {
    const $form = $(".autoreload-form").each(function () {
        const $form = $(this);
        const $triggers = $form.find(".trigger-input");

        $triggers.change(() => $form.submit());
        if ($triggers.hasClass("datepicker"))
            $triggers.datepicker("option", "onSelect", () => $form.submit());
    });
};

const setupCheckboxDisplayControl = () => {
    $(".display-control").each(function () {
        const $el = $(this);
        const className = $el.data("display-class");

        const handleChange = () => {
            const checked = $el.prop("checked");

            $(`.${className}`).hide();
            $(`.${className}.display-${checked ? "show" : "hide"}`).show();
        };

        handleChange();
        $el.change(handleChange);
    });
};

const setupAppSelector = () => {
    const $appSelector = $(".app-selector");
    const $sidebarLinks = $("#sidebar-links");
    const $appList = $("#app-list").hide();
    const $input = $appList.find("input");

    const handleEvent = (ev) => {
        const search = ev.target.value.toLowerCase();

        $appList.find("ul li").each((_, li) => {
            const itemTxt = li.innerText.toLowerCase();
            const ok = itemTxt.includes(search);
            const method = ok ? "show" : "hide";

            $(li)[method]();
        });
    };

    $input.keyup(handleEvent);

    $appSelector.find("button").click(() => {
        $appSelector.hide();
        $sidebarLinks.hide();
        $appList.show();
        $appList.find("input").focus();
    });
};

const setupCookieNotice = () => {
    const $notice = $("#cookie-notice");
    $notice.find(".btn").click(() => {
        const age = 1000 * 60 * 60 * 24 * 365 * 2; // Two years;
        const exp = new Date(Date.now() + age);
        document.cookie = `cookie_notice_accepted=true;path=/;SameSite=lax;Expires=${exp.toUTCString()}`;
        $notice.remove();
    });
};

const setupCopyToClipboard = () => {
    $(".copy-to-clipboard").on("click", function (e) {
        e.preventDefault();

        let el = document.createElement("input");
        let copyLink = $(this).attr("data-copy-planne-link");
        document.body.appendChild(el);
        el.value = copyLink;
        el.select();
        document.execCommand("copy");
        document.body.removeChild(el);

        alert("Link copiado: " + copyLink);
    });
};

const prepareFingerprint = () => {
    const data = getMetaContent("fingerprint_json");
    if (!data) {
        return;
    }

    const json = JSON.parse(data);
    for (const item of json) {
        setupFingerprint(item);
    }
};

const setupDisplayModalCode = () => {
    $(".display-modal-code").on("click", function (ev) {
        ev.preventDefault();

        const $this = $(this);
        const target = $this.attr("data-target");
        const content = $this.attr("data-content");

        $(target + " .modal-code").text(content);
    });
};

const setupRevokedVoucherNavigation = () => {
    $(".display-predecessor").each(function (e) {
        const id = this.dataset.voucherId;
        let show = false;

        $(this).click(() => {
            show = !show;

            const method = show ? "addClass" : "removeClass";
            $(`.voucher-own-${id}`)[method]("show");

            if (show) {
                $(`.voucher-direct-${id}`).removeClass("hide-voucher").show();
            } else {
                $(`.voucher-sucessor-${id}`).hide().removeClass("show");
            }
        });
    });
};

const setupSelect2 = () => {
    $(".select2").select2({
        width: "resolve",
    });
};

const setupLinksInIframe = (accessToken) => {
    if (inIframe()) {
        const links = document.querySelectorAll("a");
        const forms = document.querySelectorAll("form");

        let token = accessToken ? accessToken : getQueryParam("token");
        window.accessToken = token;

        for (let link of links) {
            const { href } = link;
            if (
                !href ||
                href.startsWith("#") ||
                href.startsWith("javascript")
            ) {
                continue;
            }

            const url = new URL(href);

            // nd means new dashboard. It will tell to redirect to new dashboard if opened in new tab
            url.searchParams.set("nd", "true");

            if (token) {
                url.searchParams.set("token", token);
            }

            link.href = url.toString();
        }

        for (let form of forms) {
            const { action } = form;
            if (!action) {
                continue;
            }

            const url = new URL(action);

            if (token) {
                url.searchParams.set("token", token);

                if (form.method === "get") {
                    var input = document.createElement("input");
                    input.type = "hidden";
                    input.name = "token";
                    input.value = token;
                    form.appendChild(input);
                }
            }

            form.action = url.toString();
        }
    }
};

const setupMessageListener = () => {
    const allowedOrigin =
        typeof window.planneDashboardOrigin === "string"
            ? window.planneDashboardOrigin
            : null;
    const reloadEvents = new Set([
        "service_fee_associated",
        "upsell_offer_created",
        "upsell_offer_updated",
    ]);

    const listener = (event) => {
        if (event.origin !== allowedOrigin) {
            return;
        }

        if (event?.data?.event_id === "update_access_token") {
            const { data } = event.data;
            const { accessToken } = data;

            setupLinksInIframe(accessToken);
        }

        if (reloadEvents.has(event?.data?.event_id)) {
            window.location.reload();
        }
    };

    window.addEventListener("message", listener);
};

const refundRequestButton = () => {
    $(".refund-request-button").on("click", function () {
        const saleId = $(this).data("saleId");
        const dashboardUrl = $(this).data("dashboardUrl");

        if (inIframe()) {
            window.parent.postMessage(
                {
                    event_id: "request_sale_refund",
                    data: {
                        saleId,
                    },
                },
                dashboardUrl
            );
        }
    });
};

const customerDetailsButton = () => {
    $(".customer-details-button").on("click", function () {
        const customerId = $(this).data("customerId");
        const dashboardUrl = $(this).data("dashboardUrl");

        if (inIframe()) {
            window.parent.postMessage(
                {
                    event_id: "customer_details",

                    data: {
                        customerId,
                    },
                },
                dashboardUrl
            );
        }
    });
};

const sidebarButton = () => {
    $(".sidebar-button").on("click", function () {
        const dashboardUrl = $(this).data("dashboardUrl");

        if (inIframe()) {
            window.parent.postMessage(
                {
                    event_id: "sidebar_toggle",
                },
                dashboardUrl
            );
        }
    });
};

const showTariffVerifications = () => {
    $(".verify-tariff").on("click", function () {
        const tariffTypeId = $(this).data("tariffTypeId");
        const dashboardUrl = $(this).data("dashboardUrl");

        if (inIframe()) {
            window.parent.postMessage(
                {
                    event_id: "verify_tariff",
                    data: {
                        tariffTypeId,
                    },
                },
                dashboardUrl
            );
        }
    });
};

const serviceFeeButton = () => {
    $(".service-fee-list-button").on("click", function () {
        const dashboardUrl = $(this).data("dashboardUrl");
        const productId = $(this).data("productId");

        if (inIframe() && dashboardUrl) {
            window.parent.postMessage(
                {
                    event_id: "open_service_fee_list",
                    data: {
                        product_id: productId,
                    }
                },
                dashboardUrl
            );
        }
    });    
};

const setupTariffGroupDashboardButton = (selector, eventId) => {
    $(selector).on("click", function (e) {
        e.preventDefault();
        const dashboardUrl = $(this).data("dashboardUrl");
        const tariffGroupId = $(this).data("tariffGroupId");
        const tariffGroupName = $(this).data("tariffGroupName");
        const isDefaultGroup = $(this).data("isDefaultGroup");

        if (inIframe() && dashboardUrl && tariffGroupId) {
            window.parent.postMessage(
                {
                    event_id: eventId,
                    data: {
                        tariffGroupId,
                        tariffGroupName,
                        isDefaultGroup,
                    },
                },
                dashboardUrl
            );
        }
    });
};

const associateServiceFeeButton = () => {
    setupTariffGroupDashboardButton(".associate-service-fee-button", "show_associate_service_fee");
};

const tariffGroupAttributesButton = () => {
    setupTariffGroupDashboardButton(".tariff-group-attributes-button", "open_tariff_group_attributes");
};

const upsellOfferCreateButton = () => {
    $(".upsell-offer-create-button").on("click", function () {
        const dashboardUrl = $(this).data("dashboardUrl");
        const productId = $(this).data("productId");
        const upsellPullId = $(this).data("upsellPullId");

        if (inIframe() && dashboardUrl) {
            window.parent.postMessage(
                {
                    event_id: "open_upsell_offer_create",
                    data: {
                        product_id: productId,
                        upsell_pull_id: upsellPullId,
                    }
                },
                dashboardUrl
            );
        }
    });    
};

const upsellOfferEditButton = () => {
    $(".upsell-offer-edit-button").on("click", function (e) {
        e.preventDefault();

        const dashboardUrl = $(this).data("dashboardUrl");
        const productId = $(this).data("productId");
        const upsellPullId = $(this).data("upsellPullId");
        const upsellOfferId = $(this).data("upsellOfferId");

        if (inIframe() && dashboardUrl) {
            window.parent.postMessage(
                {
                    event_id: "open_upsell_offer_edit",
                    data: {
                        product_id: productId,
                        upsell_pull_id: upsellPullId,
                        upsell_offer_id: upsellOfferId,
                    }
                },
                dashboardUrl
            );
        }
    });
};
